const ChevronRight = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 25 25" fill="none">
      <path d="M10.0383 6L8.62834 7.41L13.2083 12L8.62834 16.59L10.0383 18L16.0383 12L10.0383 6Z" fill={color} />
    </svg>
  );
};
export default ChevronRight;
